const renderRaffleJackpot = ($) => {
	var $jackpotEl = $("#js-raffle-jackpot--amount");
	if (!$jackpotEl.length) return;
	var $jackpotTotal = Number($jackpotEl[0].dataset.jackpot);

	function commaSeparateNumber(num) {
		let numString = num.toString();
		if (numString.length > 3) {
			let numStringArr = numString.split("").reverse();
			numStringArr.splice(3, 0, ",");
			numString = numStringArr.reverse().join("");
		}
		return `$${numString}`;
	}
	// check for user's settings that will turn off animation if they want reduced motion
	const reducedMotion =
		window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
		window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

	$.fx.off = reducedMotion;

	$({ tally: 0 }).animate(
		{ tally: $jackpotTotal },
		{
			duration: 5000,
			// only swing and linear easing options available without plugins
			easing: "swing",
			step: function () {
				$jackpotEl.text(commaSeparateNumber(Math.round(this.tally)));
			},
			// if you don't include the complete method the number stops short for some reason
			complete: function () {
				$jackpotEl.text(commaSeparateNumber(Math.round(this.tally)));
			},
		}
	);
};

export default renderRaffleJackpot;
